<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProductoAutoresponderLista"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductAutorespondersListsModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionProductAutorespondersListsModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.nombre }}</b>
          {{ $t('mEditionProductAutorespondersListsModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mEditionProductAutorespondersListsModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductAutorespondersListsModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductAutorespondersListsModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductAutorespondersListsModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    deleteProductoAutoresponderLista () {
      let data = {
        academia_autoresponder: this.$modal.element.academia_autoresponder.id_academia_autoresponder,
        lista: this.$modal.element.lista
      }

      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('producto', 'deleteProductoAutoresponderLista', { data }, [this.$route.params.id])
          .then(response => {
            this.$modal.updateData('readElement')
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductAutorespondersListsModalDelete', 'deleteProductoAutoresponderLista', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductAutorespondersListsModalDelete', 'deleteProductoAutoresponderLista', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
